import React from 'react';
import { Box, Heading, Body } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import QuotationMarkIconNavy from '../../../assets/svgs/QuotationMarkIconNavy';

const Quote: React.FC = () => (
  <Box alignItems="flex-start">
    <Box
      w={300}
      minW={300}
      alignItems="center"
      justifyContent="center"
      mr={300}
    >
      <QuotationMarkIconNavy />
    </Box>
    <Box flexDir="column" alignItems="flex-start">
      <Heading
        size={{ base: 300, tablet: 500 }}
        isDisplay
        marginBottom={{ base: 500, desktop: 500 }}
        as="p"
      >
        We’re no longer upselling to homeowners. Instead, homeowners are
        upselling to themselves. On one job, the insurance company only approved
        the roof repairs. But after seeing the siding options on the 3D model,
        the homeowner immediately applied for a loan to repair the siding of
        their house as well. Upselling has never been easier.
      </Heading>
      <Body size={300} isBold textTransform="uppercase" letterSpacing="0.1rem">
        Anne Benson
      </Body>
      <Body
        mb={400}
        size={300}
        textTransform="uppercase"
        letterSpacing="0.1rem"
      >
        owner and president, benson property
      </Body>
      <Box maxW="80px">
        <StaticImage
          src="../../../assets/images/benson_property_logo.png"
          alt="benson peroperty logo"
          objectFit="contain"
          placeholder="blurred"
        />
      </Box>
    </Box>
  </Box>
);

export default Quote;
